import resolveDependencies from './resolveDependencies';

BaseRoutes.$inject = ['$urlRouterProvider', '$stateProvider'];
export default function BaseRoutes($urlRouterProvider, $stateProvider) {
  $urlRouterProvider.when('', '/');

  $stateProvider
    .state('app.bookSeat', {
      url: '/seats',
      template: `<lb-seat-confirmation
            itinerary-id="$ctrl.itinerariesService.itinerary.Identifier"
            commit-seat="$ctrl.commitSeat(seat, flight, transport, payment)"
          >
            <lb-seat-maps></lb-seat-maps>
          </lb-seat-confirmation>`,
      controller: [
        'seatMapService',
        '$stateParams',
        '$state',
        '$scope',
        '$rootScope',
        'itinerariesService',
        'locationService',
        function (seatMapService, $stateParams, $state, $scope, $rootScope, itinerariesService, locationService) {
          this.itinerariesService = itinerariesService;

          this.commitSeat = (seat, flight, transport, payment) => {
            return seatMapService.saveSeat(seat, flight, transport, payment);
          };
          $scope.$on('exitSeatMap', () => locationService.nextPage(itinerariesService.itinerary.Search));
          $scope.$on('legSelected', (event, selectedLeg) => {
            $state.go('app.bookSeat.map', selectedLeg);
          });
          $scope.$on('backToSeatMaps', () => {
            $state.go('app.bookSeat');
          });
          $rootScope.$on('$stateChangeSuccess', function (e, toState) {
            if (toState.name === 'app.bookSeat' && seatMapService.activeTransport) {
              seatMapService.activeTransport.active = false;
              seatMapService.activeSeatMap = undefined;
            }
          });
        },
      ],
      controllerAs: '$ctrl',
      resolve: {
        resolveDependencies: resolveDependencies((resolve) => {
          require.ensure([], (require) =>
            resolve(require('../components/seatMaps/lbSeatMaps/lbSeatMaps').name, require('../components/seatMaps/lbSeatConfirmation'))
          );
        }),
        initialize: [
          'seatMapService',
          'itinerariesService',
          (seatMapService, itinerariesService) => {
            seatMapService.init(itinerariesService.itinerary.Passengers);
          },
        ],
      },
      data: {
        bodyClass: 'bg-seat-maps',
      },
    })
    .state('app.bookSeat.map', {
      url: '/{activePaxId}/{flightId}/{transportIndex}',
      template: '<lb-seat-map-container></lb-seat-map-container>',
      resolve: {
        resolveDependencies: resolveDependencies((resolve) =>
          require.ensure([], (require) => resolve(require('../components/seatMaps/lbSeatMapContainer/lbSeatMapContainer').name))
        ),
        setActiveSeatMap: [
          '$q',
          '$stateParams',
          'stateResolveService',
          ($q, $stateParams, stateResolveService) => {
            const deferred = $q.defer();
            return stateResolveService.setActiveSeatMap($stateParams, deferred);
          },
        ],
      },
      data: {
        bodyClass: 'bg-seat-maps',
      },
    })
    .state('app.prebookSeatMaps', {
      url: '/itinerary/seatmaps',
      template: `<lb-seat-confirmation
            itinerary-id="$ctrl.itinerariesService.itinerary.Identifier"
            commit-seat="$ctrl.commitSeat(seat, flight, transport, payment)"
          >
            <lb-seat-maps></lb-seat-maps>
          </lb-seat-confirmation>`,
      controller: [
        'seatMapService',
        '$state',
        '$scope',
        '$rootScope',
        'itinerariesService',
        function (seatMapService, $state, $scope, $rootScope, itinerariesService) {
          this.itinerariesService = itinerariesService;

          this.commitSeat = (seat, flight, transport, payment) => {
            return seatMapService.saveSeat(seat, flight, transport, payment);
          };
          $scope.$on('exitSeatMap', () => $state.go('app.itinerary'));
          $scope.$on('legSelected', (event, selectedLeg) => {
            $state.go('app.prebookSeatMaps.map', selectedLeg);
          });
          $scope.$on('backToSeatMaps', () => {
            $state.go('app.prebookSeatMaps');
          });
          $rootScope.$on('$stateChangeSuccess', function (e, toState) {
            if (toState.name === 'app.prebookSeatMaps' && seatMapService.activeTransport) {
              seatMapService.activeTransport.active = false;
              seatMapService.activeSeatMap = undefined;
            }
          });
        },
      ],
      controllerAs: '$ctrl',
      resolve: {
        resolveDependencies: resolveDependencies((resolve) =>
          require.ensure([], (require) =>
            resolve(require('../components/seatMaps/lbSeatMaps/lbSeatMaps').name, require('../components/seatMaps/lbSeatConfirmation'))
          )
        ),
        initialize: [
          'seatMapService',
          'itinerariesService',
          (seatMapService, itinerariesService) => {
            seatMapService.init(itinerariesService.itinerary.Passengers);
          },
        ],
      },
      data: {
        bodyClass: 'bg-seat-maps',
      },
    })

    .state('app.prebookSeatMaps.map', {
      url: '/{activePaxId}/{flightId}/{transportIndex}',
      template: '<lb-seat-map-container></lb-seat-map-container>',
      resolve: {
        resolveDependencies: resolveDependencies((resolve) =>
          require.ensure([], (require) => resolve(require('../components/seatMaps/lbSeatMapContainer/lbSeatMapContainer').name))
        ),
        setActiveSeatMap: [
          '$q',
          '$stateParams',
          'stateResolveService',
          ($q, $stateParams, stateResolveService) => {
            const deferred = $q.defer();
            return stateResolveService.setActiveSeatMap($stateParams, deferred);
          },
        ],
      },
      data: {
        bodyClass: 'bg-seat-maps',
      },
    })

    .state('app.mybookings.view', {
      url: '/{itineraryId}/{passengerId}/{pnr}/{offlinePnr}/{pcc}?{live}',
      template: '<lb-booking-details></lb-booking-details>',
      resolve: {
        resolveDependencies: resolveDependencies((resolve) =>
          require.ensure([], (require) => resolve(require('../components/myBookings/lbBookingDetails/lbBookingDetails').name))
        ),
        clearActiveBooking: [
          'activeBookingService',
          (activeBookingService) => {
            return activeBookingService.clear();
          },
        ],
      },
      data: {
        pageTitle: 'Manage Bookings - view details',
      },
    })
    .state('app.mybookings.viewpnr', {
      url: '/{pnr}?{live}',
      template: '<lb-booking-details></lb-booking-details>',
      resolve: {
        resolveDependencies: resolveDependencies((resolve) =>
          require.ensure([], (require) => resolve(require('../components/myBookings/lbBookingDetails/lbBookingDetails').name))
        ),
        clearActiveBooking: [
          'activeBookingService',
          (activeBookingService) => {
            return activeBookingService.clear();
          },
        ],
      },
      data: {
        pageTitle: 'Manage Bookings - view details',
      },
    })

    .state('app.itinerary', {
      url: '/itinerary',
      template: '<lb-itinerary></lb-itinerary>',
      resolve: {
        resolveDependencies: resolveDependencies((resolve) =>
          require.ensure([], (require) => resolve(require('../components/itinerary/lbItinerary/lbItinerary').name))
        ),
      },
      data: {
        bodyClass: 'section-itinerary',
      },
    })

    .state('app.seatmaps', {
      url: '/seatmaps/{itineraryId}/{paxId}/{source}',
      template: `<lb-seat-confirmation
            itinerary-id="$ctrl.$stateParams.itineraryId"
            commit-seat="$ctrl.seatMapService.putSeat(seat, flight, transport, payment)"
          >
            <lb-seat-maps></lb-seat-maps>
          </lb-seat-confirmation>`,
      controller: [
        'seatMapService',
        '$state',
        '$stateParams',
        '$scope',
        '$rootScope',
        function (seatMapService, $state, $stateParams, $scope, $rootScope) {
          this.seatMapService = seatMapService;
          this.$stateParams = $stateParams;
          $scope.$on('exitSeatMap', () =>
            $state.go('app.mybookings.view', {
              itineraryId: $stateParams.itineraryId,
              passengerId: $stateParams.paxId,
              source: $stateParams.source,
            })
          );
          $scope.$on('legSelected', (event, selectedLeg) => {
            $state.go('app.seatmaps.map', selectedLeg);
          });
          $scope.$on('backToSeatMaps', () => {
            $state.go('app.seatmaps', {
              itineraryId: $stateParams.itineraryId,
              paxId: $stateParams.paxId,
              source: $stateParams.source,
            });
          });
          $rootScope.$on('$stateChangeSuccess', function (e, toState) {
            if (toState.name === 'app.seatmaps' && seatMapService.activeTransport) {
              seatMapService.activeTransport.active = false;
              seatMapService.activeSeatMap = undefined;
            }
          });
        },
      ],
      controllerAs: '$ctrl',
      resolve: {
        resolveDependencies: resolveDependencies((resolve) =>
          require.ensure([], (require) =>
            resolve(require('../components/seatMaps/lbSeatMaps/lbSeatMaps').name, require('../components/seatMaps/lbSeatConfirmation'))
          )
        ),
        setActivePax: [
          '$q',
          '$stateParams',
          'stateResolveService',
          ($q, $stateParams, stateResolveService) => {
            const deferred = $q.defer();
            return stateResolveService.setActivePax($stateParams, deferred);
          },
        ],
      },
      data: {
        bodyClass: 'bg-seat-maps',
      },
    })

    .state('app.seatmaps.map', {
      url: '/{activePaxId}/{flightId}/{transportIndex}',
      template: '<lb-seat-map-container></lb-seat-map-container>',
      resolve: {
        resolveDependencies: resolveDependencies((resolve) =>
          require.ensure([], (require) => resolve(require('../components/seatMaps/lbSeatMapContainer/lbSeatMapContainer').name))
        ),
        setActiveSeatMap: [
          '$q',
          '$stateParams',
          'setActivePax',
          'stateResolveService',
          ($q, $stateParams, setActivePax, stateResolveService) => {
            const deferred = $q.defer();
            return stateResolveService.setActiveSeatMap($stateParams, deferred);
          },
        ],
      },
      data: {
        bodyClass: 'bg-seat-maps',
      },
    });
}



// WEBPACK FOOTER //
// ./src/routes/routes.base.js